import React, { Component } from 'react';
import { connect } from 'react-redux';
import './index.scss';
import { Tabs } from 'element-react';
import Banner from '../about-me/component/banner/banner';
import { actionCreators } from './store';
import HoverCard from '../home/component/hoverCard/hoverCard';

class Resources extends Component {

  state={
    tabKey:"1"
  }

  componentDidMount() {
    this.props.fetchResources();
    const pathText = this.props.location.pathname.split('/')[1]
    const headerLi = document.querySelectorAll('.pc-header__item')
    if(headerLi.length>0){
      headerLi.forEach(item=>{
        item.className = "pc-header__item"
        const label = item.dataset.jsItem ? item.dataset.jsItem.split('/')[1] : ''
        if(label===pathText){
          item.className = "pc-header__item active"
        }
      })
    }
    const { query } = this.props.location;
    if(query){
      this.setState({
        tabKey: query.val
      })
    }
    const that = this;
    this.unlisten=this.props.history.listen(route => { // 监听
      const pathArr = route.pathname.split('/')
      const { query } = route;
      if(pathArr[1]==='resources'){
        if(query&&query.val){
          that.setState({
            tabKey:query.val
          })
        }
      }
    });
  }
  
  componentWillUnmount(){
    this.unlisten && this.unlisten();
  }

  render() {

    const { resources, head } = this.props;
    // console.log('resources', resources);

    return (
      <div className="resources">
        {
          head && <Banner title={head.get('name')} desc={head.get('des')} en={head.get('en')} bannerSrc={head.get('logo')}></Banner>
        }
        <div className="resources__tab-content">
          <Tabs type="card" value={this.state.tabKey}>
            {
              resources.map((item) => {
                return (
                  <Tabs.Pane key={item.get('val')} label={item.get('name')} name={item.get('val')}>
                    <div className="resources__tab-content__tips"><span>*</span>排名不分先后</div>
                    <HoverCard hideTtile={true} hideMore={true} hoverCardData={item.get('list')}></HoverCard>
                  </Tabs.Pane>
                )
              })
            }
          </Tabs>
        </div>
      </div>
    )
  }
}

const mapState = (state) => ({
  resources: state.getIn(['resources', 'resoucers']),
  head: state.getIn(['resources', 'head'])
});

const mapDispatch = (dispatch) => ({
  fetchResources() {
    dispatch(actionCreators.fetchResourcesData());
  }
});

export default connect(mapState, mapDispatch)(Resources);
